import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TouchPointsComponent } from './pages/touchpoints/touchpoints.component';
import { SummaryComponent } from './pages/summary/summary.component';
import { LogComponent } from './pages/log/logging.component';
import { RealTimePreviewComponent } from './pages/preview/preview.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
      {
        path: '',
        redirectTo: 'select-opco',
        pathMatch: 'full'
      },
      {
        path: ':opco',
        canActivate: [MsalGuard],
        children: [
          {
            path: '',
            redirectTo: 'summary',
            pathMatch: 'prefix'
          },
          { path: 'summary', component: SummaryComponent},
          { path: 'summary/account-number/:accountNumber', component: SummaryComponent },
          { path: 'touchpoints', component: TouchPointsComponent },
          { path: 'touchpoints/account-number/:accountNumber', component: TouchPointsComponent },
          { path: 'touchpoints/testing', loadChildren: () => import('./pages/touchpoints/testing/touchpoint-testing.module').then(m => m.TouchpointTestingModule) },
          { path: 'log', component: LogComponent },
          { path: 'preview/account-number/:accountNumber', component: RealTimePreviewComponent },
          { path: 'preview', component: RealTimePreviewComponent },
          { path: 'config', loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule) },
        ]
      }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
